<template>
  <div class="" style="width: 1020px">
    <el-drawer :visible.sync="drawerVis" direction="rtl" :before-close="handleClose" size="1000px">
      <span slot="title" style="text-align: center; font-size: 16px; color: #409eff ">{{ title }}</span>
      <el-form :model="ruleForm" label-suffix="：" :rules="formRules" ref="ruleForm" label-width="110px"
        style="padding: 0 20px; overflow-y: auto; height: calc(100vh - 90px)" class="demo-ruleForm">
        <el-row :gutter="20" type="flex" justify="start" style="flex-wrap: wrap; flex-direction: row"
          :style="isReadonly ? 'pointer-events: none;' : ''">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入姓名" style="width: 350px; border: #409eff "></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <div class="button-box">
                <div v-for="(item, index) in sexList" :key="index" :class="item.value == ruleForm.sex
                  ? 'button-item active'
                  : 'button-item'
                  " @click="ruleForm.sex = item.value">
                  {{ item.name }}
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生年月" prop="birthday">
              <div class="flex-box csDate">
                <el-date-picker v-model="ruleForm.birthday" value-format="yyyy-MM-dd" type="date" placeholder="请选择出生年月"
                  :picker-options="birthdayPickerOptions">
                </el-date-picker>
                <div class="year-box">{{ ruleForm.age }}岁</div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input v-model="ruleForm.idNumber" placeholder="请输入身份证号" style="width: 350px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="身份证地址" prop="idAddress">
              <el-select v-model="idProvinceCode" placeholder="省" style="width: 130px; margin-right: 10px"
                @change="provinceChange">
                <el-option v-for="item in provinceList" :key="item.code" :label="item.label" :value="item.code">
                </el-option>
              </el-select>
              <el-select v-model="idMarketCode" placeholder="市" style="width: 130px; margin-right: 10px"
                @change="marketChange">
                <el-option v-for="item in idMarketList" :key="item.code" :label="item.label" :value="item.code">
                </el-option>
              </el-select>
              <el-select v-model="ruleForm.idAddressCode" placeholder="区" style="width: 130px; margin-right: 10px">
                <el-option v-for="item in idCountyList" :key="item.code" :label="item.label" :value="item.code">
                </el-option>
              </el-select>
              <el-input v-model="ruleForm.idAddress" placeholder="请输入详细地址" style="width: 350px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="现居地址" prop="currentAddress">
              <el-select v-model="xjProvinceCode" placeholder="省" style="width: 130px; margin-right: 10px"
                @change="provinceChange2">
                <el-option v-for="item in provinceList" :key="item.code" :label="item.label" :value="item.code">
                </el-option>
              </el-select>
              <el-select v-model="xjMarketCode" placeholder="市" style="width: 130px; margin-right: 10px"
                @change="marketChange2">
                <el-option v-for="item in xjMarketList" :key="item.code" :label="item.label" :value="item.code">
                </el-option>
              </el-select>
              <el-select v-model="ruleForm.currentAddressCode" placeholder="区" style="width: 130px; margin-right: 10px">
                <el-option v-for="item in xjCountyList" :key="item.code" :label="item.label" :value="item.code">
                </el-option>
              </el-select>
              <el-input v-model="ruleForm.currentAddress" placeholder="请输入详细地址" style="width: 350px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门" prop="deptIdArr">
              <el-input v-model="ruleForm.deptName" placeholder="请输入姓名" style="width: 350px; border: #409eff "
                v-if="isReadonly"></el-input>
              <el-cascader v-model="ruleForm.deptIdArr" popper-class="mypopperclass" ref="elcascader" v-else
                :options="deptTree.children" style="width: 350px" :props="{
                  expandTrigger: 'hover',
                  label: 'deptName',
                  value: 'deptId',
                  checkStrictly: true,
                }" @change="handleChange" @click.native="casclick"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职位" prop="positionName">
              <el-input
                v-model="ruleForm.positionName"
                placeholder="请输入职位"
                style="width: 350px"
                maxlength="20"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="职能描述" prop="duty">
              <el-input type="textarea" placeholder="请简述职业职能" v-model="ruleForm.duty" resize="none"
                :autosize="{ minRows: 4, maxRows: 16 }" maxlength="300" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入职时间" prop="jobStartTime">
              <el-date-picker v-model="ruleForm.jobStartTime" value-format="yyyy-MM-dd" type="date" style="width: 350px"
                placeholder="请选择入职时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="籍贯" prop="nativePlace">
              <el-input v-model="ruleForm.nativePlace" placeholder="请输入籍贯" style="width: 350px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否正式" prop="inInternship">
              <div class="button-box">
                <div v-for="(item, index) in isList" :key="index" :class="item.value == ruleForm.inInternship
                  ? 'button-item active'
                  : 'button-item'
                  " @click="ruleForm.inInternship = item.value">
                  {{ item.name }}
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电子邮箱" prop="mail">
              <el-input v-model="ruleForm.mail" placeholder="请输入电子邮箱"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同日期" prop="dateTime">
              <el-date-picker
                v-model="ruleForm.dateTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                unlink-panels
                @change="daterangeChange"
                clearable
                @clear="ruleForm.dateTime = null"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.inInternship == 1">
            <el-form-item label="实习时间" prop="internshipTime">
              <div class="button-box">
                <div v-for="(item, index) in sxList" :key="index" :class="item.value == ruleForm.internshipTime
                  ? 'button-item active'
                  : 'button-item'
                  " @click="ruleForm.internshipTime = item.value" style="width: 70px">
                  {{ item.name }}
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <urgentVue @getEmergencyContacts="getEmergencyContacts" :emergencyContacts="ruleForm.emergencyContacts">
            </urgentVue>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否在职" prop="leaveOrNot">
              <div class="button-box">
                <div v-for="(item, index) in zzList" :key="index" :class="item.value == ruleForm.leaveOrNot
                  ? 'button-item active'
                  : 'button-item'
                  " @click="ruleForm.leaveOrNot = item.value">
                  {{ item.name }}
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="离职时间" prop="leaveTime" v-if="ruleForm.leaveOrNot == 1">
              <el-date-picker v-model="ruleForm.leaveTime" value-format="yyyy-MM-dd" type="date" style="width: 350px"
                placeholder="请选择离职时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isReadonly">
            <el-form-item label="验证码" prop="authCode">
              <el-input v-model="ruleForm.authCode" placeholder="请输入验证码"  style="pointer-events: auto;">
                <span slot="suffix" class="send-but firm-clickable" @click="send">{{
                  sendMsg
                }}</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="notes">
              <el-input type="textarea" placeholder="请输入备注信息" v-model="ruleForm.notes" resize="none"
                :autosize="{ minRows: 4, maxRows: 16 }" maxlength="300" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!isReadonly">
            <el-form-item style="float: right">
              <el-button @click="handleClose">取消</el-button>
              <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import * as API from "@/assets/api/firm/firmTalent.js";
import moment from "moment";
import urgentVue from "./urgentVue.vue";
const defaultData = {
  name: "", // 姓名
  sex: 1, // 性别0:女 1：男
  birthday: "", // 生日
  age: "",
  currentAddressCode: "", // 现居住地编码
  currentAddress: "", // 现居住地详细地址
  phone: "", // 联系方式
  deptIdArr: [],
  deptId: "", // 部门 id
  department: "", // 部门名称
  duty: "", // 职责
  positionName: "", // 职位
  jobStartTime: "", // 入职时间
  nativePlace: "", // 籍贯
  mail: "", // 电子邮箱
  dateTime: null,
  contractStartTime: "", // 合同开始时间
  contractEndTime: "", // 合同到期时间
  inInternship: 1, // 是否实习员工0:正式1:实习
  internshipTime: 0, // 实习时间0:一个月1:三个月2:六个月3:十二个月
  emergencyContacts: [
    {
      name: "",
      phone: "",
      friendship: 0,
    },
  ], // 紧急联系人
  leaveOrNot: 0, // 离职与否 0 否（在职）1是（离职）
  authCode: "",
  leaveOrNot: 0, // 离职与否 0 否（在职）1是（离职）
  leaveTime: "", // 离职时间
  notes: "", // 备注
  idNumber: "", // 身份证号
  idAddressCode: "", // 身份证居住地编码
  idAddress: "", // 身份证详细地址
};
export default {
  components: {
    urgentVue,
  },
  data() {
    const that = this;
    return {
      title: "",
      isReadonly: false,
      drawerVis: false,
      // 出生年月：不可选今天之后的日期
      birthdayPickerOptions: {
        disabledDate(time) {
          const end = new Date()
          end.setHours(0, 0, 0, 0)
          return time.getTime() > end.getTime()
        },
      },
      ruleForm: JSON.parse(JSON.stringify(defaultData)),
      age: "",
      sexList: [
        {
          name: "男",
          value: 1,
        },
        {
          name: "女",
          value: 0,
        },
      ],
      isList: [
        {
          name: "正式员工",
          value: 0,
        },
        {
          name: "实习员工",
          value: 1,
        },
      ],
      sxList: [
        {
          name: "1个月",
          value: 0,
        },
        {
          name: "3个月",
          value: 1,
        },
        {
          name: "6个月",
          value: 2,
        },
        {
          name: "12个月",
          value: 3,
        },
      ],
      zzList: [
        {
          name: "在职",
          value: 0,
        },
        {
          name: "离职",
          value: 1,
        },
      ],
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        sex: [
          { required: true, message: "请选择性别", trigger: "change" },
        ],
        birthday: [
          { required: true, message: "请选择出生年月", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: "^[1][3,4,5,6,7,8,9][0-9]{9}$",
            message: "请输入合法的手机号！",
            trigger: "blur",
          },
        ],
        mail: [
          { type: "email", message: "请输入正确的邮箱地址!", trigger: "blur" },
        ],
        deptIdArr: [
          { required: true, message: "请选择部门", trigger: "change" },
        ],
        duty: [
          { required: true, message: "请简述职业职能", trigger: "blur" },
        ],
        positionName: [
          { required: true, message: "请输入职位", trigger: "blur" },
          { max: 20, message: "职位名称不能超过20个字", trigger: "blur" },
        ],
        jobStartTime: [
          { required: true, message: "请选择入职时间", trigger: "blur" },
        ],
        dateTime: [
          { required: true, message: "请选择合同日期", trigger: "change" },
        ],
        authCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        inInternship: [
          { required: true, message: "请选择是否正式", trigger: "change" },
        ],
        internshipTime: [
          { required: true, message: "请选择实习时间", trigger: "change" },
        ],
        leaveOrNot: [
          { required: true, message: "请选择是否在职", trigger: "change" },
        ],
        leaveTime: [
          { required: true, message: "请选择离职时间", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              // 仅在离职场景下校验：离职时间必须 > 入职时间
              if (that.ruleForm.leaveOrNot !== 1) {
                callback();
                return;
              }
              if (!value || !that.ruleForm.jobStartTime) {
                callback();
                return;
              }
              const start = moment(that.ruleForm.jobStartTime, "YYYY-MM-DD");
              const end = moment(value, "YYYY-MM-DD");
              if (end.isAfter(start, "day")) {
                callback();
              } else {
                callback(new Error("离职时间必须大于入职时间"));
              }
            },
            trigger: "blur",
          },
        ],
        idNumber: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            pattern:
              /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: "请输入合法的身份证号！",
            trigger: "blur",
          },
        ],
        idAddress: [
          { required: true, message: "请完善身份证地址", trigger: "blur" },
        ],
      },
      // 省列表
      provinceList: [],
      // 身份证
      // 省code
      idProvinceCode: "",
      // 市列表
      idMarketList: [],
      // 市code
      idMarketCode: "",
      // 区县列表
      idCountyList: [],
      // 现居地址
      // 省code
      xjProvinceCode: "",
      // 市列表
      xjMarketList: [],
      // 市code
      xjMarketCode: "",
      // 区县列表
      xjCountyList: [],
      sendMsg: "发送验证码",
    };
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    deptTree: {
      default: "",
    },
    detail: {},
  },
  created() {
    this.drawerVis = this.drawer;
    // 从Vuex获取地址数据
    const addressList = this.$store.getters.getAddRes;
    if (addressList && addressList.length > 0) {
      this.provinceList = addressList;
    } else {
      this.getAddressSelect();
    }
  },
  computed: {
    // 查看模式仅展示，不参与校验，避免回显后仍出现红框/校验提示
    formRules() {
      return this.isReadonly ? {} : this.rules;
    },
  },
  watch: {
    title(newVal) {
      if (newVal == "查看员工") {
        this.isReadonly = true;
      } else {
        this.isReadonly = false;
      }
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    "ruleForm.inInternship": {
      handler(newVal) {
        if (newVal == 1) {
          this.rules.internshipTime[0].required = true;
        } else {
          this.rules.internshipTime[0].required = false;
        }
      },
      immediate: true,
      deep: true,
    },
    // 获取年龄
    "ruleForm.birthday": {
      handler(newVal) {
        if (newVal) {
          this.ruleForm.age = moment().format("YYYY") - newVal.split("-")[0];
        } else {
          this.ruleForm.age = "";
        }
      },
      deep: true,
    },
    drawer(newVal) {
      this.drawerVis = newVal;
      if (newVal) {
        // 如果是添加模式（title 为"添加员工"或 detail 为空），才重置表单
        if (this.title == "添加员工" || !this.detail || !this.detail.id) {
          this.$nextTick(() => {
            if (this.$refs.ruleForm) {
              this.$refs.ruleForm.resetFields();
            }
          })
          this.sendMsg = '发送验证码'
          clearInterval(this.timeFun);
          // 清空地址相关数据
          this.idProvinceCode = "";
          this.idMarketCode = "";
          this.idCountyList = [];
          this.xjProvinceCode = "";
          this.xjMarketCode = "";
          this.xjCountyList = [];
          // 重置表单数据
          this.ruleForm = {
            name: "", // 姓名
            sex: 1, // 性别0:女 1：男
            birthday: "", // 生日
            age: "",
            currentAddressCode: "", // 现居住地编码
            currentAddress: "", // 现居住地详细地址
            phone: "", // 联系方式
            deptIdArr: [],
            deptId: "", // 部门 id
            department: "", // 部门名称
            duty: "", // 职责
            positionName: "", // 职位
            jobStartTime: "", // 入职时间
            nativePlace: "", // 籍贯
            mail: "", // 电子邮箱
            dateTime: null,
            contractStartTime: "", // 合同开始时间
            contractEndTime: "", // 合同到期时间
            inInternship: 1, // 是否实习员工0:正式1:实习
            internshipTime: 0, // 实习时间0:一个月1:三个月2:六个月3:十二个月
            emergencyContacts: [
              {
                name: "",
                phone: "",
                friendship: 0,
              },
            ], // 紧急联系人
            authCode: "", // 验证码
            leaveOrNot: 0, // 离职与否 0 否（在职）1是（离职）
            leaveTime: "", // 离职时间
            notes: "", // 备注
            idNumber: "", // 身份证号
            idAddressCode: "", // 身份证居住地编码
            idAddress: "", // 身份证详细地址
          };
        } else {
          // 编辑/查看模式，重置验证码相关
          this.sendMsg = '发送验证码'
          clearInterval(this.timeFun);
        }
      }
    },
    detail: {
      handler(newVal) {
        if (this.title == "添加员工") {
          return;
        }
        if (!newVal || !newVal.id) {
          return;
        }
        // 使用 $nextTick 确保在 drawer 打开后再执行数据回显
        this.$nextTick(() => {
          // 避免关闭抽屉后异步回显仍把上一份数据写回表单
          if (!this.drawerVis) {
            return;
          }
          if (this.title == "添加员工") {
            return;
          }
          this.ruleForm = JSON.parse(JSON.stringify(newVal))
          this.ruleForm.department = newVal.deptName;
          this.$set(this.ruleForm, "dateTime", [this.ruleForm.contractStartTime, this.ruleForm.contractEndTime])
          if (this.ruleForm.idAddressCode && this.provinceList && this.provinceList.length > 0) {
            this.IdFindParents(this.ruleForm.idAddressCode, this.provinceList);
          }
          if (this.ruleForm.currentAddressCode && this.provinceList && this.provinceList.length > 0) {
            this.XjFindParents(
              this.ruleForm.currentAddressCode,
              this.provinceList
            );
          }
          if (this.deptTree && this.deptTree.children && this.deptTree.children.length > 0) {
            this.deptTree.children.forEach((item) => {
              if (item.deptId == newVal.deptId) {
                this.ruleForm.deptIdArr = [newVal.deptId];
              } else {
                if (item.children) {
                  item.children.forEach((items) => {
                    if (items.deptId == newVal.deptId) {
                      this.ruleForm.deptIdArr = [items.pid, newVal.deptId];
                    }
                  });
                }
              }
            });
          }
          this.$nextTick(() => {
            if (this.$refs.ruleForm) {
              this.$refs.ruleForm.clearValidate();
            }
          });
        });
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    // 回显身份证地址
    IdFindParents(areaCode, data) {
      const provinceCode = areaCode.substring(0, 2);
      const cityCode = areaCode.substring(0, 4);
      const province = data.find((p) => p.code === provinceCode);
      const city = province.children.find((c) => c.code === cityCode);
      this.idProvinceCode = provinceCode;
      this.idMarketList = province.children;
      this.idMarketCode = cityCode;
      this.idCountyList = city.children;
      return { province, city };
    },
    // 回显现居地址
    XjFindParents(areaCode, data) {
      const provinceCode = areaCode.substring(0, 2);
      const cityCode = areaCode.substring(0, 4);
      const province = data.find((p) => p.code === provinceCode);
      const city = province?.children?.find((c) => c.code === cityCode);
      this.xjProvinceCode = provinceCode;
      this.xjMarketList = province.children;
      this.xjMarketCode = cityCode;
      this.xjCountyList = city.children;
      return { province, city };
    },
    // 部门一级可以选择
    casclick(event) {
      let that = this;
      this.$nextTick(() => {
        let d = document.getElementsByClassName("mypopperclass");
        if (d[0] && !d[0].onclick) {
          d[0].onclick = function (e) {
            if (e.target.className == "el-cascader-node__label") {
              e.target.previousElementSibling.click();
              that.$refs.elcascader.dropDownVisible = false;
            }
          };
        }
      });
    },
    // 部门切换
    handleChange(val) {
      console.log(val);
      if (val) {
        if (val.length == 1) {
          this.ruleForm.department = this.deptTree.children.find((item) => {
            return item.deptId == val[0];
          }).deptName;
          this.ruleForm.deptId = val[0];
        } else {
          this.ruleForm.department = this.deptTree.children
            .find((item) => {
              return item.deptId == val[0];
            })
            .children.find((p) => p.deptId == val[1]).deptName;
          this.ruleForm.deptId = val[1];
        }
      }

    },
    // 获取地址
    getAddressSelect() {
      API.getAddressSelect().then((res) => {
        this.provinceList = res.data;
      });
    },
    // 切换身份证省
    provinceChange(val) {
      const province = this.provinceList.find((p) => p.code == val);
      this.idMarketList = province && province.children ? province.children : [];
      // 省变更后，市/区都要清空，避免 v-model 旧值在新选项中找不到而直接显示为数字编码
      this.idMarketCode = "";
      this.idCountyList = [];
      this.ruleForm.idAddressCode = "";
    },
    // 切换身份证市
    marketChange(val) {
      const city = this.idMarketList.find((p) => p.code == val);
      this.idCountyList = city && city.children ? city.children : [];
      this.ruleForm.idAddressCode = "";
    },
    // 切换现居省
    provinceChange2(val) {
      const province = this.provinceList.find((p) => p.code == val);
      this.xjMarketList = province && province.children ? province.children : [];
      // 省变更后同步清空市/区，防止显示旧编码数字
      this.xjMarketCode = "";
      this.xjCountyList = [];
      this.ruleForm.currentAddressCode = "";
    },
    // 切换现居市
    marketChange2(val) {
      const city = this.xjMarketList.find((p) => p.code == val);
      this.xjCountyList = city && city.children ? city.children : [];
      this.ruleForm.currentAddressCode = "";
    },
    // 获取紧急联系人
    getEmergencyContacts(val) {
      this.ruleForm.emergencyContacts = val;
    },
    // 发送验证码
    send() {
      if (!this.ruleForm.phone) {
        this.$tool.PromptBox("error", "请填写手机号后获取验证码！");
      } else if (/^1(3|4|5|6|7|8)\d{9}$/.test(this.ruleForm.phone) == false) {
        this.$tool.PromptBox("error", "请填写正确的手机号后获取验证码！");
      } else {
        if (this.sendMsg == '再次发送验证码' || this.sendMsg == '发送验证码') {
          let data = {
            data: {
              type: 0,
              mail: "",
              mobile: this.ruleForm.phone,
              authCodeBusiness: '14'
            },
          };
          API.sendAuthCode(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "发送成功");
              this.isSend = false;
              let timer = 60;
              this.sendMsg = timer + "s";
              this.timeFun = setInterval(() => {
                --timer;
                this.sendMsg = timer + "s";
                if (timer == 0) {
                  this.isSend = true;
                  this.sendMsg = "再次发送验证码";
                  clearInterval(this.timeFun);
                }
              }, 1000);
            }
          });
        }
      }

    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.companyId = this.$store.getters.getCompany.id;
          if (this.ruleForm.id) {
            this.editEmployee();
          } else {
            this.addEmployee();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 切换合同日期
    daterangeChange(val) {
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        this.ruleForm.contractStartTime = val[0];
        this.ruleForm.contractEndTime = val[1];
      } else {
        this.ruleForm.contractStartTime = "";
        this.ruleForm.contractEndTime = "";
      }
    },
    // 添加员工
    addEmployee() {
      let data = {
        data: this.ruleForm,
      };
      API.addEmployee(data).then((res) => {
        if (res.code == 0) {
          this.$tool.PromptBox("success", "操作成功");
          this.handleClose();
        }
      });
    },
    // 编辑员工
    editEmployee() {
      let data = {
        data: this.ruleForm,
      };
      API.editEmployee(data).then((res) => {
        if (res.code == 0) {
          this.$tool.PromptBox("success", "操作成功");
          this.handleClose();
        }
      });
    },
    // 关闭弹框
    handleClose() {
      // 清空表单数据
      this.ruleForm = JSON.parse(JSON.stringify(defaultData));
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
      // 清空地址相关数据
      this.idProvinceCode = "";
      this.idMarketCode = "";
      this.idCountyList = [];
      this.xjProvinceCode = "";
      this.xjMarketCode = "";
      this.xjCountyList = [];
      // 清空验证码相关
      this.sendMsg = '发送验证码';
      clearInterval(this.timeFun);
      // 关闭 drawer
      this.drawerVis = false;
      this.$emit("handleClose", this.drawerVis);
    },
  },
};
</script>

<style lang="less" scoped>
// 限制在本抽屉内，避免污染全局表单/单选样式
/deep/ .el-input__inner {
  border: 1px solid #409eff  !important;
  height: 35px;
}

.button-box {
  display: flex;
  align-items: center;

  .button-item {
    width: 90px;
    height: 35px;
    border: 1px solid #409eff ;
    text-align: center;
    border-radius: 5px;
    line-height: 35px;
    background: #fff;
    color: #409eff ;
    margin-right: 10px;
    font-size: 12px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .active {
    background: rgba(97, 144, 232, 0.27);
  }

  .button-item:last-child {
    margin-right: 0;
  }
}

.year-box {
  width: 90px;
  height: 41px;
  background: rgba(97, 144, 232, 0.27);
  border: 1px solid #409eff ;
  border-radius: 5px;
  text-align: center;
  line-height: 37px;
  color: #409eff ;
  margin-left: -2px;
  z-index: 999;
  box-sizing: border-box;
}

.csDate {
  width: 350px;

  /deep/ .el-input__inner {
    border-right: 0 !important;
    border-radius: 5px 0px 0 5px;
    width: 260px;
    border: 1px solid #409eff  !important;
  }
}

/deep/.el-textarea__inner {
  font-size: 12px;
}

/deep/.el-range-input {
  font-size: 12px;
}

/deep/.el-form-item .el-form-item__label {
  font-size: 14px;
}

.send-but {
  font-size: 12px;
  color: #409eff ;
  cursor: pointer;
  margin-right: 5px;
}
</style>

<style lang="less">
/* cascader 下拉挂到 body，仅限 mypopperclass，避免隐藏全局 radio */
.mypopperclass .el-radio,
.mypopperclass .el-radio__inner,
.mypopperclass .el-radio__input {
  position: absolute;
  display: none;
}
</style>
